import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectKeys'
})
export class ObjectKeysPipe implements PipeTransform {
  transform(object: {}): string[] {
    if (typeof object !== 'object') {
      return [];
    }

    return Object.keys(object);
  }
}
